/* eslint-disable import/prefer-default-export */
import type { State } from '../models'
import { forEach } from 'lodash'

export function setPending(data: State, value: boolean) {
  const out = { ...data }
  forEach(out?.flags || {}, x => {
    x.pending = value
  })
  return { ...out, pending: value }
}
